<template>
  <section>
    <h3 class="boss-joboffer-title boss-setting">
      掲載中求人
    </h3>
    <table
      class="unstriped boss-table"
    >
      <thead>
        <tr>
          <th class="boss-table-head-center">
            管理用求人名
          </th>
          <th class="boss-table-head-center">
            掲載期間
          </th>
          <th class="boss-table-head-center">
            掲載中面接情報ページ名
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-if="jobs.length">
          <tr
            v-for="(job, i) in jobs"
            :key="i"
          >
            <td
              class="boss-table-data"
              :data-test="`job-name-${i}`"
            >
              {{ job.jobName }}
            </td>
            <td
              class="boss-table-data text-center"
              :data-test="`job-period-${i}`"
            >
              {{ job | periodLabel }}
            </td>
            <td
              class="boss-table-data"
              :data-test="`job-interview-countermeasure-${i}`"
            >
              {{ job.interviewCountermeasureName | countermeasureLabel }}
            </td>
          </tr>
        </template>
        <tr v-else>
          <td
            colspan="3"
            data-test="no-jobs"
          >
            ※現在掲載中の求人はありません
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import _ from 'lodash'

export default {
  filters: {
    periodLabel (val) {
      return !_.isEmpty(val) ? `${val.startDate} ～ ${val.endDate}` : ''
    },
    countermeasureLabel (val) {
      return val || '面接情報が設定されていません'
    }
  },
  props: {
    jobs: {
      type: Array,
      required: true
    }
  }
}
</script>
